import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { ElementContainer } from '@root/src/web/components/ElementContainer';
import { LeftColumn } from '@root/src/web/components/LeftColumn';
import { ContainerTitle } from '@root/src/web/components/ContainerTitle';
import { Hide } from '@root/src/web/components/Hide';
import { Flex } from '@root/src/web/components/Flex';
import { space } from '@guardian/src-foundations';
import { from } from '@guardian/src-foundations/mq';
const containerStyles = css `
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	width: 100%;
`;
const margins = css `
	margin-top: ${space[2]}px;
	/*
   Keep spacing at the bottom of the container consistent at 36px, regardless of
   breakpoint, based on chat with Harry Fisher
*/
	margin-bottom: ${space[9]}px;
`;
const rightMargin = css `
	${from.wide} {
		margin-right: 68px;
	}
`;
const padding = css `
	padding: 0 10px;
`;
const Container = ({ children, padded, verticalMargins, stretchRight, }) => (_jsx("div", Object.assign({ css: [
        containerStyles,
        padded && padding,
        verticalMargins && margins,
        !stretchRight && rightMargin,
    ] }, { children: children }), void 0));
export const ContainerLayout = ({ title, fontColour, description, url, sectionId, sideBorders = false, centralBorder, showTopBorder = false, padSides = true, padContent = true, verticalMargins = true, borderColour, backgroundColour, children, leftContent, stretchRight = false, leftColSize, }) => (_jsx(ElementContainer, Object.assign({ sectionId: sectionId, showSideBorders: sideBorders, showTopBorder: showTopBorder, padded: padSides, borderColour: borderColour, backgroundColour: backgroundColour }, { children: _jsxs(Flex, { children: [_jsx(LeftColumn, Object.assign({ showRightBorder: centralBorder === 'full', borderColour: borderColour, showPartialRightBorder: centralBorder === 'partial', size: leftColSize }, { children: _jsxs(_Fragment, { children: [_jsx(ContainerTitle, { title: title, fontColour: fontColour, description: description, url: url }, void 0), leftContent] }, void 0) }), void 0), _jsxs(Container, Object.assign({ padded: padContent, verticalMargins: verticalMargins, stretchRight: stretchRight }, { children: [_jsx(Hide, Object.assign({ when: "above", breakpoint: "leftCol" }, { children: _jsx(ContainerTitle, { title: title, fontColour: fontColour, description: description, url: url }, void 0) }), void 0), children] }), void 0)] }, void 0) }), void 0));
